import { Map } from 'immutable';
import {
    getOwnFixedNumber,
    getOwnMobileNumber,
} from 'flow/selectors/selectors';
import { Extension } from 'flow/types/Extension';
import { State } from 'flow/types/State';
import { TypedMap } from 'flow/types/TypedMap';
import { getActiveCalls } from 'flow/selectors/call-selectors';
import { ActiveLineData } from 'flow/types/ActiveLineData';
import { Contact } from 'flow/types/Contact';

export const extensionToCallIsInCallWithYou = (
    state: State,
    extensionToCall?: TypedMap<Extension>,
) => {
    if (!extensionToCall) {
        return false;
    }

    const activeCalls =
        getActiveCalls(state, extensionToCall.get('key')) || Map();

    return activeCalls.some((activeCall: TypedMap<ActiveLineData>) => {
        const remoteNumber =
            activeCall.get('direction') === 'remote_start'
                ? activeCall.get('destination')
                : activeCall.get('source');

        return [getOwnFixedNumber(state), getOwnMobileNumber(state)].includes(
            remoteNumber,
        );
    });
};

export const sessionIsNonCallTelavoxTicket = (
    activeSession: TypedMap<ActiveLineData>,
) =>
    !!(
        activeSession?.get('isTelavoxTicketNonCall') ||
        activeSession?.getIn(['bagVariables', 'telavox.omni.ticket'])
    );

export const getFullNameFromContact = (contact: TypedMap<Contact>) => {
    const firstName = contact.get('firstName', '');
    const lastName = contact.get('lastName', '');

    return `${firstName} ${lastName}`;
};
